import { Component, OnInit, Inject } from '@angular/core';
import { Utility } from '../../common/utility';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { DialogService } from '../../shared/services/dialog.service';
import { ConsultationHistoryService } from './consultation-history.service';
import { TravelAgendaModel } from '../../models/consultation-history/travel-agenda.model';
import { MedicalConditionModel } from '../../models/consultation-history/medical-condition.model';
import { PatientVaccines } from '../../models/consultation-history/patient-vaccines.model';
import { PatientVaccineSchedules } from '../../models/consultation-history/patient-vaccine-schedules.model';
import { PatientOtherVaccines } from '../../models/consultation-history/patient-other-vaccines.model';
import { ConsultationStatusService } from '../consultation/consultation-status/consultation-status.service';
import { Router } from '@angular/router';
import { VaccinationService } from './vaccination/vaccination.service';
import { NoteService } from './note/note.service';
import { AppConstants } from './../../shared/constants/constants';
import { SharedService } from '../../shared/services/share.services';
import { FullAuditTrailService } from './full-audit-trail/full-audit-trail.service';
import { PatientInfoAuditTrailService } from './patient-info-audit-trail/patient-info-audit-trail.service';
import { AttachmentService } from './attachment/attachment.service';
import { PriorityAuditTrailService } from './priority-audit-trail/priority-audit-trail.service';
import { LabTestDataService } from '../master-data/lab-test-data/lab-test-data.service';
@Component({
    selector: 'app-consultation-history',
    templateUrl: 'consultation-history.component.html',
    providers: [ConsultationHistoryService, ConsultationStatusService, PriorityAuditTrailService,
        VaccinationService, NoteService, SharedService, FullAuditTrailService, 
        AttachmentService,PatientInfoAuditTrailService, LabTestDataService]
})

export class ConsultationHistoryComponent implements OnInit {
    public appConstants = AppConstants;
    public klass = 'consultationhistory';
    public index = 0;
    public selectedHistory = null;
    public histories = [];
    public travelAgendas: TravelAgendaModel[];
    public travelAgenda: any;
    public tripCountries = [];
    public medicalConditions: MedicalConditionModel[];
    public prescription = [];
    public consultationId = [];
    public invoices = [];
    public fullAuditTrail: any;
    public patientAuditTrail: any;
    public priorityAuditTrail: Array<any>;
    public vaccines: {
        patientVaccines: PatientVaccines,
        patientVaccinesSchedules: PatientVaccineSchedules,
        patientOtherVaccines: PatientOtherVaccines,
    };
    public labTest: any;
    public isCompleteHistory = true;
    public user: {
        patientId: string,
        id: string
    };
    public consultationHistoryId: string = null;
    public tabs = {
        travelAgenda: 0,
        medicalCondition: 1,
        vaccination: 2,
        prescription: 3,
        labTest: 4,
        note: 5,
        fullAuditTrail: 6,
        priorityAuditTrail: 7,        
        patientInfoAuditTrail: 8,
        invoice: 9,
        attachment: 10,
        
    };
    private reportTokenId: string;
    public vaccinationSchedules: any[];
    public administedVaccines: any[];
    public previousOtherVaccine: any[];
    public consultationNotes: any[];
    height: number;
    width: number;
    patientName: string;
    practitionerName: string;
    constructor(public utility: Utility,
        public dialogService: DialogService,
        public dialogRef: MdDialogRef<ConsultationHistoryComponent>,
        public consultationHistoryService: ConsultationHistoryService,
        public consultationStatusService: ConsultationStatusService,
        public router: Router,
        public vaccinationService: VaccinationService,
        public noteService: NoteService,
        public shareServices: SharedService,
        public fullAuditTrailService: FullAuditTrailService,
        public patientInfoAuditTrailService: PatientInfoAuditTrailService,
        public priorityAuditTrailService: PriorityAuditTrailService,
        public attachmentService: AttachmentService,
        @Inject(MD_DIALOG_DATA) public data: {
            patientId: string,
            id: string,
            height: number,
            width: number
        }
    ) { }

    ngOnInit() {
        this.height = this.data ? ((this.data.height - 50) || null) : null;
        this.reportTokenId = this.utility.randomKey();
        this.user = this.data;
        // this.selectedHistory = this.histories.length ? this.histories[0] : null;
        this.selectedHistory = null;
        // this.changeConsultationHistory(this.selectedHistory);
        this.consultationHistoryService.getPatientDetail(this.user.patientId).subscribe(response => {
            if (response) {
                const data = response.json();
                this.patientName = (data['firstName'] ? data['firstName'] : '')
                    + ' ' + (data['middleName'] ? (data['middleName'] + ' ') : '') + (data['surName'] ? data['surName'] : '');
            }
        });
        this.consultationHistoryService.getConsultationHistory(this.user.patientId).subscribe(result => {
            if (result) {
                this.histories = result.json();
            }
            // this.consultationId = this.histories;
            // this.selectedHistory = this.histories.length ? this.histories[0] : null;
            this.selectedHistory = null;
            this.changeTab({ index: this.tabs.travelAgenda });
            // this.changeConsultationHistory(this.selectedHistory);

        });
    }

    changeConsultationHistory(consultation: any) {
        this.consultationHistoryId = consultation ? consultation.id : null;
        this.isCompleteHistory = this.consultationHistoryId === null;
        this.practitionerName = consultation ? consultation['description'] : null;
        switch (this.index) {
         
            case this.tabs.travelAgenda:
                this.getTravelAgenda(this.consultationHistoryId);
                break;
            case this.tabs.medicalCondition:
                this.getMedicalCondition(this.consultationHistoryId);
                break;
            case this.tabs.vaccination:
                this.getVaccination(this.consultationHistoryId);
                break;
            case this.tabs.prescription:
                this.getPrescription(this.consultationHistoryId);
                break;
            case this.tabs.labTest:
                this.getLabtest(this.consultationHistoryId);
                break;
            case this.tabs.note:
                this.getConsultationNote(this.consultationHistoryId);
                break;
            case this.tabs.invoice:
                this.getInvoices(this.consultationHistoryId);
                break;
            case this.tabs.fullAuditTrail:
                this.getFullAuditTrail(this.consultationHistoryId);
                break;
            case this.tabs.priorityAuditTrail:
                this.getPriorityAuditTrail(this.consultationHistoryId);
            case this.tabs.patientInfoAuditTrail:
                    this.getPatientInfoAuditTrail(this.consultationHistoryId);
                break;
            // default:
            //     this.getTravelAgenda(this.consultationHistoryId);
        }

        // this.getTravelAgenda(this.consultationHistoryId);
        // this.getMedicalCondition(this.consultationHistoryId);
        // this.getPatientVaccines(this.consultationHistoryId);
        // this.getPrescription(this.consultationHistoryId);
    }
    getInvoices(consultationHistoryId) {
        const arrayId = [];
        if (consultationHistoryId != null) {
            arrayId.push({ consultationId: consultationHistoryId });
        } else {
            for (let i = 0; i < this.histories.length; i++) {
                arrayId.push({ consultationId: this.histories[i].id });
            }
        }
        this.consultationHistoryService.getInvoiceHistory(arrayId).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.invoices = data;
                }
            }
        );
    }

    getFullAuditTrail(consultationHistoryId) {
        this.fullAuditTrailService.getFullAuditTrail(this.data.patientId, this.consultationHistoryId).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.fullAuditTrail = data['list'];
                }
            }
        );
    }

    getPriorityAuditTrail(consultationHistoryId) {
        this.priorityAuditTrailService.getPriorityAuditTrail(this.data.patientId, this.consultationHistoryId).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.priorityAuditTrail = data['list'];
                }
            }
        );
    }

    getPatientInfoAuditTrail(consultationHistoryId) {
        this.patientInfoAuditTrailService.getPatientInfoAuditTrail(this.data.patientId, this.consultationHistoryId).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.patientAuditTrail = data['list'];
                }
            }
        );
    }
    getTravelAgenda(consultationHistoryId) {
        if (consultationHistoryId != null) {
            const arrayId = [];
            arrayId.push(consultationHistoryId);
            this.consultationHistoryService.getTravelAgenda(arrayId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    this.travelAgenda = data;
                }
            });
        } else {
            const arrayId = [];
            for (let i = 0; i < this.histories.length; i++) {
                arrayId.push(this.histories[i].id);
            }
            this.consultationHistoryService.getTravelAgendaCompleteHistory(arrayId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    this.travelAgenda = data;
                    this.tripCountries = [];
                    if (this.travelAgenda) {
                        if (this.travelAgenda.length > 0) {
                            this.travelAgenda.forEach(travel => {
                                const countries = <Array<any>>travel.tripCountries || [];
                                if (countries.length > 0) {
                                    countries.forEach((x, index, self) => {
                                        let i = -1;
                                        if (this.tripCountries.length > 0) {
                                            i = this.tripCountries.findIndex(y => y.id === self[index].id);
                                        }
                                        if (i < 0) {
                                            this.tripCountries.push({ id: x.id, name: x.name });
                                        }
                                    });
                                }
                            });
                        }
                    }
                }
            });
        }
    }

    getMedicalCondition(consultationHistoryId) {
        if (consultationHistoryId != null) {
            const arrayId = [];
            arrayId.push(consultationHistoryId);
            this.consultationHistoryService.getMedicalCondition(arrayId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    this.medicalConditions = data;
                }
            });
        } else {
            const arrayId = [];
            for (let i = 0; i < this.histories.length; i++) {
                arrayId.push(this.histories[i].id);
            }
            this.consultationHistoryService.getMedicalConditionCompleteHistory(arrayId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    const arr = <Array<any>>data;
                    /*const newArr = [];
                    arr.forEach((val, pos, self) => {
                        let index = -1;
                        if (newArr.length > 0) {
                            index = newArr.findIndex(x => x.medicalConditionId === self[pos].medicalConditionId);
                        }
                        if (index < 0) {
                            newArr.push(val);
                        }
                    });*/
                    this.medicalConditions = arr;
                }
            });
        }
    }

    getPatientVaccines(patientConsultationId) {
        this.consultationHistoryService.getPatientVacines(patientConsultationId).subscribe(result => {
            if (result) {
                const data = result.json();
            }
        });
    }
    getVaccination(patientConsultationId: string) {
        this.administedVaccine(patientConsultationId);
        this.patientPreviousOtherVaccine(patientConsultationId);
        this.vaccinationSchedule(patientConsultationId);
    }

    // Vaccination

    vaccinationSchedule(patientConsultationId) {
        this.vaccinationService.vaccinationSchedules(this.data.patientId, patientConsultationId).subscribe(
            (result) => {
                if (result) {
                    this.vaccinationSchedules = result.json();
                    if (this.vaccinationSchedules.length) {
                        this.vaccinationSchedules.forEach(x => {
                            x.schedules.forEach(element => {
                                element.toolTipStr = element.siteToAdministerId ? 'Administered on ' +
                                    this.utility.convertDateToLocalString(new Date(element.vaccinateDate), 'DD-MMM-YYYY')
                                    + ' - By ' + element.administeredBy +
                                    ' - Batch No ' + element.batchNumber.toString() : 'Not Administered';
                            });
                        });
                    }
                }
            }
        );
    }

    administedVaccine(patientConsultationId) {
        this.vaccinationService.administedVaccine(this.data.patientId, patientConsultationId).subscribe(
            result => {
                if (result) {
                    const data = result.json();
                    this.administedVaccines = data['data'];
                }
            }
        );
    }
    patientPreviousOtherVaccine(patientConsultationId) {
        this.vaccinationService.previousOtherVaccine(this.data.patientId, patientConsultationId).subscribe(
            result => {
                if (result) {
                    this.previousOtherVaccine = result.json();
                }
            }
        );
    }

    // note
    getConsultationNote(patientConsultationId) {
        this.noteService.getConsultationNote(patientConsultationId, this.data.patientId).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.consultationNotes = data;
                }
            }
        );
    }
    saveConsultationNote(noteData: any) {
        this.noteService.saveConsultationNote(noteData.consultationId, noteData.note).subscribe(
            (result) => {
                if (result) {
                    this.getConsultationNote(noteData.consultationId);
                }
            }
        );
    }

    getPrescription(consultationHistoryId) {
        if (consultationHistoryId != null) {
            this.consultationHistoryService.getPrescription(consultationHistoryId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    this.prescription = data;
                }
            });
        } else {
            const arrayId = [];
            for (let i = 0; i < this.histories.length; i++) {
                arrayId.push(this.histories[i].id);
            }
            this.consultationHistoryService.getPrescriptionCompleteHistory(arrayId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    this.prescription = data;

                }
            });
        }
    }
    getLabtest(consultationHistoryId) {
        if (consultationHistoryId != null) {
            this.consultationHistoryService.getLabTest(consultationHistoryId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    this.labTest = data;
                }
            });
        } else {
            const arrayId = [];
            for (let i = 0; i < this.histories.length; i++) {
                arrayId.push(this.histories[i].id);
            }
            this.consultationHistoryService.getLabTestCompleteHistory(arrayId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    this.labTest = data;
                }
            });
        }
    }
    close() {
        this.dialogRef.close();
    }

    /**
     * function identify the tab we choosed
     */
    changeTab(e) {
        this.index = e.index;
        this.changeConsultationHistory(this.selectedHistory);
    }
    printReport() {
        this.patientRecordsReport(this.consultationHistoryId);
        // switch (this.index) {
        //     case this.tabs.travelAgenda:
        //         this.patientRecordsReport(this.consultationHistoryId);
        //         break;
        //     case this.tabs.medicalCondition:
        //         break;
        //     case this.tabs.vaccination:
        //         break;
        //     case this.tabs.prescription:
        //         this.medicalPrescriptionReport(this.consultationHistoryId);
        //         break;
        //     case this.tabs.labTest:
        //         break;
        //     case this.tabs.note:
        //         break;

        //     // default:
        //     //     this.getTravelAgenda(this.consultationHistoryId);
        // }
    }

    medicalPrescriptionReport(consultationId) {
        if (consultationId) {
            this.consultationHistoryService.isPatientHasPerscriptions(consultationId).subscribe(
                (result) => {
                    if (result) {
                        const reportName = 'Prescription';
                        const params = {
                            [AppConstants.reportParameter.historyId]: consultationId,
                            [AppConstants.reportParameter.pdfprintType]: 'pdf',
                            [AppConstants.reportParameter.patientCopy]: result.status,
                        };
                        this.shareServices.showReport(reportName, params);
                    }
                }
            );
        }
    }
    patientRecordsReport(consultationId) {
        if (consultationId) {
            const reportName = 'PatientRecord';
            const params = {
                [AppConstants.reportParameter.historyId]: consultationId,
                [AppConstants.reportParameter.pdfprintType]: 'pdf'
            };
            this.shareServices.showReport(reportName, params);
        }
    }

    navigateCashSale() {
        if (this.user.patientId && this.consultationHistoryId) {
            this.close();
            this.router.navigate(['consultation/cash-sale/', this.consultationHistoryId, this.user.patientId, 'add']);
        }
    }

    navigate(ev) {
        if (ev === true) {
            this.close();
        }
    }

    reloadVaccination(event) {
        if (event === true) {
            this.getVaccination(this.consultationHistoryId);
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/consultation-history.component.ts